import * as React from "react";
import { useState } from "react";
import { config } from "../../../../config/domain";
import digiLocker_img from "../../../../assets/images/digi-locker.webp";
import pdf_icon from "../../../../assets/images/pdf_icon.png";
import LoginService, { getAccData } from "../../../service/login/loginService";
import Checkbox from "../../../generic/checkbox";
import {getinvAccDet} from "../../../service/login/loginService"
import {
  CreateChildServiceRequestDetails,
  CreateServiceRequestDetails,
  createSRDocumentUpload,
  fetchDigiLockerUrl,
  GetAllNewExistingSRDetails,
  getClientDet,
  GetDepositoryDetails,
  GetEquityReactivationClientValidation,
  getMergeDocumentBase64,
} from "../../../service/serviceRequest/srApiService";
import { useQuery } from "../../../service/urlHelper";
import { AddressModificationForm } from "./addressModificationForm";
import { getArea, GetNameDOBValidation } from "../../../service/generic/otherApi";
import {
  getDocumentCategory,
  getMaskedAdhar,
  getOCRResp,
} from "../../generic/qCCheck";
import { asyncGetServiceRequest } from "../../../service/postLogin/clientProfileAPIService";
import * as esignService from "../../../service/esign/esignService";
import {
  KRADocumentUploadForm,
  ViewKRADocuments,
} from "../KRADocumentUpload/KRADocumentUpload";
import VideoVerification from "../videoVerification/VideoVerification";
export const AddressFormat = {
  addressLine1: "",
  addressLine2: "",
  addressLine3: "",
  addressLine4: "",
  city: "",
  country: "",
  pincode: "",
  stateStr: "",
  area: "",
  proof: "DrivingLicense",
  fileName: "",
  fileData: "",
  isDigiLocker: false,
  photoDetails: "",
  pdfXMLResp: "",
};
var count = 0;
let invOnlyAcc = getinvAccDet();
export const AddressModification: React.FC<any> = (props) => {
  const parentDetails: any = JSON.parse(
    localStorage.getItem("accReactParentDetails") || "{}"
  );
  const [accReactFlow, setAccReactFlow] = useState<Boolean>(false);
  const addressConsent = useQuery().get("consent");
  const consentType = useQuery().get("consentType");
  const [serviceReqListArr, setServiceReqListArr] = useState<any>();
  let storedList = window.sessionStorage.getItem("serviceReqList");
  React.useEffect(() => {
      setServiceReqListArr(storedList ? JSON.parse(storedList) : []);
  }, [storedList]);
  let consentList: any = undefined,
    invAddress: boolean = true;
  if (getAccData("cnsntLst")) {
    consentList = getAccData("cnsntLst");
  } else if (localStorage.getItem("cnsntLst")) {
    consentList = JSON.parse(localStorage.getItem("cnsntLst") || "{}");
  }
  if (consentList && consentList.length > 0) {
    let consentName = consentList.find((list: any) => {
      if (list.name === "invAddress") return list;
      // if (list.name === "invAddress" || list.name === "accReact") return list;
    });
    if (consentName && consentName.name === "invAddress") {
      invAddress = false;
    } 
    // else if(consentName && consentName.name === "accReact")  {
    //     setAccReactFlow(true);
    //   } 
    else {
      invAddress = true;
    }
    
  }
  const RedirectnSource = window.localStorage.getItem("source");
  const soad = useQuery().get("soad");
  const sr = useQuery().get("srID");
  const digie = localStorage.getItem("digie");
  let personalDetails: any = window.localStorage.getItem("personalDetails");
  const digieResubmit = localStorage.getItem("digieResubmit");
  const [prefilledBase64, setPrefilledBase64] = useState<any>();
  const [qcStatus, setQCStatus] = useState<any>("Verification in Process");
  const [existingAddressSR, setExistingAddressSR] = useState<any>();
  const [dormantMoreThanYear, setDormantMoreThanYear] = useState<any>(undefined);
  const [existingPermanentAddress, setExistingPermanentAddress] =
    useState<any>();
  const [existingCorrspondenceAddress, setExistingCorrspodenceAddress] =
    useState<any>();
  const [accountCode, setAccountCode] = useState<any>();
  const [permanentAddress, setPermanentAddress] = React.useState<any>({
    ...AddressFormat,
  });
  const [kraDetails, setKraDetails] = React.useState<any>({
    webSign: {},
    panCard: {},
    photo: {},
  });
  const [corrspondenceAddress, setCorrspondenceAddress] = React.useState<any>({
    ...AddressFormat,
  });
  const [sameAsPermanent, setSameAsPermanent] = useState<boolean>(true);
  const digiLockerUrl = "https://api.digitallocker.gov.in/public/oauth2/1/authorize";
  const dgLockerLinkUrl = digiLockerUrl + "?client_id=" + config.client_Id + "&response_type=code&redirect_uri=" + config.reDirectUrl + "?&state=" + JSON.stringify({});
  const source = useQuery().get("source");
  const [viewAddress, setViewAddress] = useState<any>(true);
  const [showEditAddressOptions, setshowEditAddressOptions] = useState<any>(false);
  const [showPrerequisites, setshowPrerequisites] = useState<any>(false);
  const [showFinalAddress, setShowFinalAddress] = useState<any>(false);
  const [showRevalidateAddress, setShowRevalidateAddress] = useState<any>(false);
  const [showWithoutDigilocker, setshowWithoutDigilocker] = useState<any>(false);
  const [disabledButton, setDisabledButton] = useState<boolean>(false);
  const [fullName, setFullName] = useState<any>();
  const [enableEsign, setEnableEsign] = useState<boolean>(false);
  const [enableDigilocker, setEnableDigilocker] = useState<boolean>(false);
  // const [loader, props.setLoader] = useState(true);
  const [autoQC, setAutoQC] = useState("NA");
  const [serReqId, setSerReqId] = useState<any>("");
  const [areaOptions, setAreaOptions] = useState<any>([]);
  const [areaCOOptions, setCOAreaOptions] = useState<any>([]);
  const [checkAutoQcFlag, setCheckAutoQcFlag] = useState<any>();
  const [userConsent, setUserConsent] = useState(false);
  const [sourceAddress, setSourceAddress] = useState<Boolean>(false);
  const [ViewAddressSame, setViewAddressSame] = useState<Boolean>(false);
  const [dpType, setDpType] = useState<String>("");
  const [ipvcode, setIpvcode] = useState<String>("");
  const [showIpvScreen, setShowIpvScreen] = useState<Boolean>(false);
  const [showPrerequisiteLink, setShowPrerequisiteLink] = useState<Boolean>(true);
  const [addrType, setAddrType] = useState(1);
  const [videoContent, setVideoContent] = React.useState<any>();
  const [nameDOBValidation, setNameDOBValidation] = useState<any>();
  const [nameDOBMismatch, setNameDOBMismatch] = useState<any>();

  const srID = (() => {
    return props.childSr
      ? props.getChildSr(2)
      : window.localStorage.getItem("srId")
      ? window.localStorage.getItem("srId")
      : sr;
  })();
  React.useEffect(() => {
    if (!props.childSr && soad && soad === "dig") {
      if (isKraDetails()) {
        setDisabledButton(true);
      } else {
        setDisabledButton(false);
      }
    }
  }, [kraDetails]);

  // React.useEffect(() => {
  //   if(videoContent && ipvcode) {
  //   if (!props.childSr) {
  //     if (showFinalAddress) {
  //        setshowEditAddressOptions(false);
  //        props.setLoader(true);
  //        setViewAddress(true);
  //        submitRequest();
  //      } else {
  //        setshowEditAddressOptions(true);
  //        setViewAddress(false);
  //      }
  //      if (serReqId && prefilledBase64) {
  //        esignService.getEsignUrl(
  //          prefilledBase64,
  //          serReqId,
  //          "address"
  //        );
  //      }
  //    } else {
  //      submitRequest();
  //    }
  //   } 
  // }, [videoContent]);
  React.useEffect(() => {
    getDobValidation();
    }, []);
  const getDobValidation = async()=>{
    props.setLoader(true);
    const nameDOBValidation = await GetNameDOBValidation();
    if(nameDOBValidation && nameDOBValidation.validationStatus) {
      setNameDOBValidation(nameDOBValidation.validationStatus)
      if(nameDOBValidation.result[0] && nameDOBValidation.result[0].data) {
          const result = nameDOBValidation?.result?.[0]?.data;
          const nameMsg = result?.nameMsg?.toLowerCase();
          const dobMsg = result?.dobMsg?.toLowerCase();
          if (nameMsg !== "matched with database" && dobMsg !== "matched with database") {
            setNameDOBMismatch("nameanddob");
          } else if (nameMsg === "matched with database" && dobMsg !== "matched with database") {
            setNameDOBMismatch("dob");
          } else if (nameMsg !== "matched with database" && dobMsg === "matched with database") {
            setNameDOBMismatch("name");
          } else {
            setNameDOBMismatch("");
          }
      }
    }
    props.setLoader(false);
  }

  React.useEffect(() => {
    getDemat();
    localStorage.removeItem("personalDetails");
    setDormantMoreThanYear(localStorage.getItem("DormantMoreThanYear"))
    if(localStorage.getItem("DormantMoreThanYear") == 'true') {
      setShowRevalidateAddress(true);
      setShowPrerequisiteLink(true);
    }
    if (window.location.href.includes("account-reactivation"))  {
      setAccReactFlow(true);
    } else {
      localStorage.removeItem("DormantMoreThanYear");
      setShowPrerequisiteLink(false);
    }
    if (soad === "dig" || digie === "Yes") {
      if (!srID) getAddressDetails();
      else {
        //  window.localStorage.removeItem("srId");
      }
      personalDetails = JSON.parse(personalDetails);
      let addressFormatObj: any;
      setViewAddress(true);
      if (digie === "Yes") {
        if (!personalDetails) {
          window.localStorage.removeItem("digie");
          setShowFinalAddress(false);
          getAddressDetails();
        } else {
          if(props.childSr)
            setShowFinalAddress(true);
          else
            setShowFinalAddress(false);
        }
      }

      if (personalDetails) {
        addressFormatObj = {
          aadharName: personalDetails.aadharName,
          addressLine1: personalDetails.addressLine1,
          stateStr: personalDetails.stateStr,
          pincode: personalDetails.pincode,
          city: personalDetails.city,
          isDigiLocker: true,
          fileData: personalDetails.fileData,
          fileName: personalDetails.fileName,
          proof: "Aadhar",
          autoQC: personalDetails.autoQC,
          photoDetails: personalDetails.photoDetails,
          pdfXMLResp: personalDetails.pdfXMLResp,
        };
        if (soad === "dig") {
          let fileObj = {
            ["fileName"]: "Digilocker_photo.jpg",
            ["fileData"]: personalDetails.photoDetails,
            ["imgSrc"]: personalDetails.photoDetails,
            ["documentTypeName"]: "ProfilePhoto",
          };
          setKraDetails({
            ...kraDetails,
            ["photo"]: fileObj ? fileObj : {},
          });
        }
      }

      if (addressFormatObj) {
        setSourceAddress(true);
        setPermanentAddress(addressFormatObj);
        setSameAsPermanent(true);
        props.setLoader(false);
        // submitRequest(addressFormatObj);
      }
    } else if (soad === "nondig" || digie === "No") {
      window.localStorage.removeItem("digie");
      if (srID) {
        window.localStorage.removeItem("srId");
        props.setLoader(true);
        getExistingOldAddress(srID);
      } else {
        getAddressDetails();
      }
      setViewAddress(false);
    } else {
      if (srID) {
        props.setLoader(true);
        getExistingOldAddress(srID);
      } else {
        if (!props.childSr) checkExistingAddressSR();
        getAddressDetails();
      }
    }
  }, []);
  const getDemat = async () => {
    let personalDet = await getClientDet("D", LoginService.getAccData("accTyp"));
    setDpType(personalDet.DpTyp);
  };
  const getDepositoryDet = async () => {
    try {
      const resp = await GetDepositoryDetails();

      if (resp && resp.dPIdField && resp.dPAccountNumberField) {
        return resp.dPIdField + resp.dPAccountNumberField;
      } else {
        return "None";
      }
    } catch (error) {
      openSRErrorPopup();
    }
  };
  const clearLocalStorage = () => {
    window.localStorage.removeItem("digie");
    window.localStorage.removeItem("digieResubmit");
    window.localStorage.removeItem("rejectFlow");
    window.localStorage.removeItem("srId");
    window.localStorage.removeItem("");
    window.localStorage.removeItem("ipvcode");
    window.localStorage.removeItem("imageData");
    window.localStorage.removeItem("latitude");
    window.localStorage.removeItem("longitude");
  };
  async function getExistingOldAddress(srId: any) {
    try {
      props.setLoader(true);
      setViewAddress(false);
      if (typeof srId === "string") {
        srId = parseInt(srId);
      }
      let resp = await GetAllNewExistingSRDetails(srId);
      if (resp && resp.result) {
        if (resp.result.old_data && resp.result.old_data.accountcode) {
          setAccountCode(resp.result.old_data.accountcode);
        }
        if (
          resp &&
          resp.result &&
          resp.result.new_data &&
          resp.result.new_data.newPermanentAdr
        ) {
          setPermanentAddress(
            getAddressObj(resp.result.new_data.newPermanentAdr)
          );
        }
        if (
          resp &&
          resp.result &&
          resp.result.new_data &&
          resp.result.new_data.newCorrespondenceAdr
        ) {
          setCorrspondenceAddress(
            getAddressObj(resp.result.new_data.newCorrespondenceAdr)
          );
        }
        let resultSameAsPermant =
          JSON.stringify(resp.result.new_data.newPermanentAdr).toLowerCase() ===
          JSON.stringify(
            resp.result.new_data.newCorrespondenceAdr
          ).toLowerCase();
        if (resultSameAsPermant) {
          setSameAsPermanent(true);
        } else {
          setSameAsPermanent(false);
        }
        if (!resultSameAsPermant) {
          let corresAreaResp = await getArea(
            resp.result.new_data.newCorrespondenceAdr.pincode
          );
          if (
            corresAreaResp.data &&
            corresAreaResp.data.areas &&
            corresAreaResp.data.areas.length > 0
          ) {
            const list = corresAreaResp.data.areas.map((respObj: any) => {
              return {
                value: toCamelCase(respObj.toLowerCase()),
                display: toCamelCase(respObj.toLowerCase()),
              };
            });
            setCOAreaOptions(list);
          }
        }
        let areaResp = await getArea(
          resp.result.new_data.newPermanentAdr.pincode
        );
        if (
          areaResp.data &&
          areaResp.data.areas &&
          areaResp.data.areas.length > 0
        ) {
          props.setLoader(true);
          const list = areaResp.data.areas.map((respObj: any) => {
            return {
              value: toCamelCase(respObj.toLowerCase()),
              display: toCamelCase(respObj.toLowerCase()),
            };
          });
          setAreaOptions(list);
          let isDigResubmit = localStorage.getItem("digieResubmit");
          if (isDigResubmit === "Yes") {
            setshowEditAddressOptions(true);
            props.setLoader(false);
          } else {
            setshowWithoutDigilocker(true);
            props.setLoader(false);
          }
        } else {
          openSRErrorPopup();
        }
      } else {
        openSRErrorPopup();
      }
    } catch (error) {
      openSRErrorPopup();
    }
  }
  function setAddressFlag() {
    if (sameAsPermanent) {
      setSameAsPermanent(false);
      setPermanentAddress(permanentAddress);
      setCorrspondenceAddress(permanentAddress);
    } else {
      setSameAsPermanent(true);
    }
  }

  async function getAddressDetails() {
    props.setLoader(true);
    try {
      if ((soad && soad === "nondig") || (digie && digie === "No")) {
        props.setLoader(true);
      }
      let addressDetails = await GetEquityReactivationClientValidation();
      if (addressDetails) {
        if (addressDetails.result && addressDetails.result.length > 0) {
          if(addressDetails.result[0].NCDEX == "Y"){
            setAddrType(1);
          } else if(addressDetails.result[0].NCDEX == "N" && addressDetails.result[0].DP_Type == "NSDL"){
            setAddrType(2);
          } else {
            setAddrType(3);
          }
          setAccountCode(addressDetails.result[0].AccountCode);
          setFullName(addressDetails.result[0].FullAcName);
          setExistingPermanentAddress(
            addressDetails.result[0].PermanentAddress[0]
          );
          setExistingCorrspodenceAddress(
            addressDetails.result[0].CorrespondenceAddress[0]
          );

          if (
            JSON.stringify(
              addressDetails.result[0].PermanentAddress[0]
            ).toLowerCase() ===
            JSON.stringify(
              addressDetails.result[0].CorrespondenceAddress[0]
            ).toLowerCase()
          ) {
            setViewAddressSame(true);
          } else {
            setViewAddressSame(false);
          }
          if (!(soad && soad === "dig")) {
            if (digie && digie === "Yes" && personalDetails) {
              return;
            }
            if (!soad || !digie) {
              setPermanentAddress(
                getAddressObj(addressDetails.result[0].PermanentAddress[0])
              );
              setCorrspondenceAddress(
                getAddressObj(addressDetails.result[0].CorrespondenceAddress[0])
              );
              if (addressDetails.result[0].PermanentAddress[0].PinCode) {
                let areaResp = await getArea(
                  addressDetails.result[0].PermanentAddress[0].PinCode
                );
                if (
                  areaResp.data &&
                  areaResp.data.areas &&
                  areaResp.data.areas.length > 1
                ) {
                  const list = areaResp.data.areas.map((respObj: any) => {
                    return {
                      value: toCamelCase(respObj.toLowerCase()),
                      display: toCamelCase(respObj.toLowerCase()),
                    };
                  });
                  setAreaOptions(list);
                }
                if ((soad && soad === "nondig") || (digie && digie === "No")) {
                  setshowWithoutDigilocker(true);
                }
              }
            }
          }
        }
      }
      props.setLoader(false);
    } catch (err) {
      openSRErrorPopup();
    }
  }
  const isEmptyObject = (obj: any) => {
    if (JSON.stringify(obj) !== "{}") return true;
    return false;
  };
  const isKraDetails = () => {
    if (
      !props.childSr &&
      isEmptyObject(kraDetails.webSign) &&
      isEmptyObject(kraDetails.panCard)
    ) {
      return true;
    } else {
      return false;
    }
  };
  function getFormattedString(addressLine1: any) {
    if (addressLine1) {
      if (addressLine1.includes(",")) {
        addressLine1 = addressLine1.replaceAll(",", " ");
      }
      addressLine1 = addressLine1.toLowerCase();
      addressLine1 = addressLine1.trim();
      addressLine1= addressLine1.replace(/\s+/g, ' ');
    }
    return addressLine1;
  }
  const toCamelCase = (string: any) => {
    if (string)
      return string.replace(/\w\S*/g, function (txt: any) {
        return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
      });
    else return "";
  };
  function getImgSrc(fileData: string, fileName: string) {
    if (fileData && fileName) {
      if (fileName.split(".")[1] !== "pdf") {
        let imgSrc =
          "data:image/" + fileName.split(".")[1] + ";base64," + fileData;
        return imgSrc;
      } else return undefined;
    } else return undefined;
  }
  function getAddressObj(addressObj: any, documents?: any) {
    let addressFormatObj = undefined;
    if (props.childSr)
      addressFormatObj = {
        addressLine1: toCamelCase(
          getFormattedString(
            addressObj.address_line_1
              ? addressObj.address_line_1
              : addressObj.AddressLine1
          )
        ),
        addressLine2: toCamelCase(
          getFormattedString(
            addressObj.address_line_2
              ? addressObj.address_line_2
              : addressObj.AddressLine2
          )
        ),
        addressLine3: toCamelCase(
          getFormattedString(
            addressObj.address_line_3
              ? addressObj.address_line_3
              : addressObj.AddressLine3
          )
        ),
        addressLine4: toCamelCase(
          getFormattedString(
            addressObj.address_line_4 !== ""
              ? addressObj.address_line_4
              : addressObj.AddressLine4 !== ""
              ? addressObj.AddressLine4
              : ""
          )
        ),
        pincode: addressObj.pincode ? addressObj.pincode : addressObj.PinCode,
        stateStr: toCamelCase(
          addressObj.state
            ? addressObj.state.toLowerCase()
            : addressObj.State.toLowerCase()
        ),
        city: toCamelCase(
          addressObj.city
            ? addressObj.city.toLowerCase()
            : addressObj.City.toLowerCase()
        ),
        country: toCamelCase(
          addressObj.Country ? addressObj.Country.toLowerCase() : ""
        ),
        proof: "DrivingLicense",
        fileData: "",
        fileName: "",
        imgSrc: "",
        isDigiLocker: false,
      };
    else if (sourceAddress) {
      addressFormatObj = {
        aadharName: addressObj.aadharName,
        addressLine1: addressObj.addressLine1,
        stateStr: addressObj.stateStr,
        pincode: addressObj.pincode,
        city: addressObj.city,
        isDigiLocker: true,
        fileData: addressObj.fileData,
        fileName: addressObj.fileName,
        proof: "Aadhar",
      };
    } else {
      addressFormatObj = {
        addressLine1: toCamelCase(
          getFormattedString(
            addressObj.address_line_1
              ? addressObj.address_line_1
              : addressObj.AddressLine1
          )
        ),
        addressLine2: toCamelCase(
          getFormattedString(
            addressObj.address_line_2
              ? addressObj.address_line_2
              : addressObj.AddressLine2
          )
        ),
        addressLine3: toCamelCase(
          getFormattedString(
            addressObj.address_line_3
              ? addressObj.address_line_3
              : addressObj.AddressLine3
          )
        ),
        addressLine4: toCamelCase(
          getFormattedString(
            addressObj.address_line_4 !== ""
              ? addressObj.address_line_4
              : addressObj.AddressLine4 !== ""
              ? addressObj.AddressLine4
              : ""
          )
        ),
        pincode: addressObj.pincode ? addressObj.pincode : addressObj.PinCode,
        stateStr: toCamelCase(
          addressObj.state
            ? addressObj.state.toLowerCase()
            : addressObj.State.toLowerCase()
        ),
        area: "",
        city: toCamelCase(
          addressObj.city
            ? addressObj.city.toLowerCase()
            : addressObj.City.toLowerCase()
        ),
        country: toCamelCase(
          addressObj.Country ? addressObj.Country.toLowerCase() : ""
        ),
        proof: documents ? documents.documentTypeName : "DrivingLicense",
        fileData: documents ? documents.fileData : undefined,
        fileName: documents ? documents.fileName : undefined,
        imgSrc: documents
          ? getImgSrc(documents.fileData, documents.fileName)
          : "",
        isDigiLocker: false,
      };
    }
    return addressFormatObj;
  }

  async function checkExistingAddressSR() {
    setExistingAddressSR("");
  }
  const mergeDocuments = async (addressObj: any) => {
    if (
      addressObj &&
      addressObj.fileName &&
      addressObj.fileData &&
      addressObj.fileName2 &&
      addressObj.fileData2
    ) {
      let uploadImageObj = {
        applicationId: accountCode,
        image1: addressObj.fileData,
        image2: addressObj.fileData2,
        imagename1: addressObj.fileName,
        imagename2: addressObj.fileName2,
      };
      try {
        let mergerResp = await getMergeDocumentBase64(uploadImageObj);
        if (mergerResp) {
          addressObj.fileName = "merge_document.pdf";
          addressObj.fileData = mergerResp;
        }
      } catch (e) {
        openSRErrorPopup();
      }
    }
  };
  function getFinalAddressLines(addressObj: any) {
    let finalAddressObj: any = {
      finalAddressLineforPermanent1: "",
      finalAddressLineforPermanent2: "",
      finalAddressLineforPermanent3: "",
      finalAddressLineforPermanent4: "",
    };
    finalAddressObj.finalAddressLineforPermanent1 = addressObj.addressLine1;
    finalAddressObj.finalAddressLineforPermanent2 = addressObj.addressLine2;
    finalAddressObj.finalAddressLineforPermanent3 = addressObj.addressLine3;
    finalAddressObj.finalAddressLineforPermanent4 = addressObj.addressLine4;
    // //console.log("finalAddressObj", Object.keys(finalAddressObj));

    Object.keys(finalAddressObj).map((key: any) => {
      // //console.log('ele',key);
      finalAddressObj[key] = finalAddressObj[key]
        ? finalAddressObj[key].trim()
        : finalAddressObj[key];

      if (finalAddressObj[key] && finalAddressObj[key].length < 5) {
        let str = "";
        for (let i = 0; i < 5 - finalAddressObj[key].length; i++) {
          str += "-";
        }
        finalAddressObj[key] += str;
      } else if (!finalAddressObj[key]) finalAddressObj[key] = "-----";
    });

    return finalAddressObj;
  }
  const getAttachment = (addressObj:any, attachment:any) => {
    attachment.push({
      fileName: "Digilocker_photo.jpg",
      fileData: addressObj.photoDetails,
      documentTypeName: "ProfilePhoto",
    });
    attachment.push({
      fileName: "Adderss_PDF_XML.xml",
      fileData: permanentAddress.pdfXMLResp,
      documentTypeName: "AadhaarXML",
    });
    
    return attachment;
  }
  async function submitRequest(addressFormatObj?: any) {
    let addressObj = permanentAddress ? permanentAddress : addressFormatObj;
    var autoQC = "No";
    if (addressObj && addressObj.proof === "Aadhar" && !props.childSr) {
      props.setLoader(true);
      let maskedObj = {
        proof: addressObj.proof,
        accountCode: accountCode,
        fileData: addressObj.fileData,
        fileName: addressObj.fileName,
      };
      let respObj = await getMaskedAdhar(maskedObj, true, true);
      if (respObj.fileData && respObj.fileName) {
        addressObj.fileData = respObj.fileData;
        addressObj.fileName = respObj.fileName;
      } else {
        addressObj.fileData = respObj;
      }
    }
    if (
      !sameAsPermanent &&
      corrspondenceAddress.proof === "Aadhar" &&
      !props.childSr
    ) {
      let maskedObj = {
        proof: corrspondenceAddress.proof,
        accountCode: accountCode,
        fileData: corrspondenceAddress.fileData,
        fileName: corrspondenceAddress.fileName,
      };
      let respObj = await getMaskedAdhar(maskedObj, true, true);
      if (respObj.fileData && respObj.fileName) {
        corrspondenceAddress.fileData = respObj.fileData;
        corrspondenceAddress.fileName = respObj.fileName;
      } else {
        corrspondenceAddress.fileData = respObj;
      }
    }
    if (addressObj.fileName2 && addressObj.fileData2) {
      if (addressObj.proof === "Aadhar") {
        let maskedObj = {
          proof: addressObj.proof,
          accountCode: accountCode,
          fileData: addressObj.fileData2,
          fileName: addressObj.fileName2,
        };
        let respObj = await getMaskedAdhar(maskedObj, true, true);
        if (respObj.fileData && respObj.fileName) {
          addressObj.fileData2 = respObj.fileData;
          addressObj.fileName2 = respObj.fileName;
        } else {
          addressObj.fileData2 = respObj;
        }
      }
      await mergeDocuments(addressObj);
    }
    if (
      !sameAsPermanent &&
      corrspondenceAddress &&
      corrspondenceAddress.fileName &&
      corrspondenceAddress.fileData
    ) {
      if (corrspondenceAddress.fileName2 && corrspondenceAddress.fileData2) {
        if (corrspondenceAddress.proof === "Aadhar") {
          let maskedObj = {
            proof: corrspondenceAddress.proof,
            accountCode: accountCode,
            fileData: corrspondenceAddress.fileData2,
            fileName: corrspondenceAddress.fileName2,
          };
          let respObj = await getMaskedAdhar(maskedObj, true, true);
          if (respObj.fileData && respObj.fileName) {
            corrspondenceAddress.fileData2 = respObj.fileData;
            corrspondenceAddress.fileName2 = respObj.fileName;
          } else {
            corrspondenceAddress.fileData2 = respObj;
          }
        }
        await mergeDocuments(corrspondenceAddress);
      }
    }
    let finalAddressLineforPermanent1 = "",
      finalAddressLineforPermanent2 = "",
      finalAddressLineforPermanent3 = "",
      finalAddressLineforPermanent4 = "";
    let finalAddressLineforCA1 = "",
      finalAddressLineforCA2 = "",
      finalAddressLineforCA3 = "",
      finalAddressLineforCA4 = "";
    let finalAddressLineIndex1 = 0,
      finalAddressLineIndex2 = 0;
    if ((soad && soad === "dig") || (digie && digie === "Yes")) {
      finalAddressLineforPermanent1 = toCamelCase(
        getFormattedString(addressObj.addressLine1.substring(0, 30))
      );
      finalAddressLineforPermanent2 = toCamelCase(
        getFormattedString(addressObj.addressLine1.substring(30, 60))
      );
      finalAddressLineforPermanent3 = toCamelCase(
        getFormattedString(addressObj.addressLine1.substring(60, 90))
      );
      finalAddressLineforPermanent4 = toCamelCase(
        getFormattedString(addressObj.addressLine1.substring(90, 120))
      );
      if (sameAsPermanent) {
        finalAddressLineforCA1 = finalAddressLineforPermanent1;
        finalAddressLineforCA2 = finalAddressLineforPermanent2;
        finalAddressLineforCA3 = finalAddressLineforPermanent3;
        finalAddressLineforCA4 = finalAddressLineforPermanent4;
      }

      autoQC = permanentAddress ? permanentAddress.autoQC : addressObj.autoQc;
    } else {
      let autoQC2: any;
      if (
        accountCode &&
        permanentAddress.proof !== "NREGA job card" &&
        !props.childSr
      ) {
        let documentCategory = { name: "", id: 0 };
        documentCategory = getDocumentCategory(
          permanentAddress.proof,
          documentCategory
        );
        let requestPayload = {
          applicationid: accountCode,
          base64document: permanentAddress.fileData,
          documentcategory: documentCategory.name,
          documentid: documentCategory.id,
          source: "DIY",
        };
        let ocrResp: any;
        ocrResp = await getOCRResp(documentCategory.name, requestPayload);
        if (
          ocrResp &&
          ocrResp.data &&
          ocrResp.data.status === "completed" &&
          ocrResp.data.result.extraction_output
        ) {
          let result = ocrResp.data.result.extraction_output;
          let finalAddress =
            permanentAddress.addressLine1 +
            permanentAddress.AddressLine2 +
            permanentAddress.area +
            permanentAddress.city +
            permanentAddress.stateStr +
            permanentAddress.pincode;
          if (
            result &&
            result.address &&
            result.address.toLowerCase() === finalAddress.toLowerCase() &&
            result.pincode.toLowerCase() ===
              permanentAddress.pincode.toLowerCase() &&
            result.state.toLowerCase() ===
              permanentAddress.stateStr.toLowerCase() &&
            result.name_on_card === fullName
          ) {
            autoQC = "Yes";
          } else {
            autoQC = "No";
          }
        }
      }
      if (
        accountCode &&
        corrspondenceAddress.proof !== "NREGA job card" &&
        !sameAsPermanent &&
        !props.childSr
      ) {
        let documentCategory = { name: "", id: 0 };
        documentCategory = getDocumentCategory(
          corrspondenceAddress.proof,
          documentCategory
        );
        let requestPayload = {
          applicationid: accountCode,
          base64document: corrspondenceAddress.fileData,
          documentcategory: documentCategory.name,
          documentid: documentCategory.id,
          source: "DIY",
        };
        let ocrResp: any;
        ocrResp = getOCRResp(documentCategory.name, requestPayload);
        if (
          ocrResp.data &&
          ocrResp.data.status === "completed" &&
          ocrResp.data.result.extraction_output
        ) {
          let result = ocrResp.data.result.extraction_output;
          let finalAddress =
            corrspondenceAddress.addressLine1 +
            corrspondenceAddress.AddressLine2 +
            corrspondenceAddress.area +
            corrspondenceAddress.pincode;

          if (
            result &&
            result.address &&
            result.address.toLowerCase() === finalAddress.toLowerCase() &&
            result.pincode.toLowerCase() ===
              corrspondenceAddress.pincode.toLowerCase() &&
            result.state.toLowerCase() ===
              corrspondenceAddress.stateStr.toLowerCase() &&
            result.name_on_card === fullName
          ) {
            autoQC2 = "Yes";
          } else {
            autoQC2 = "No";
          }
        }
      }
      if (!sameAsPermanent) {
        if (autoQC === "Yes" && autoQC2 === "Yes") {
          autoQC = "Yes";
        } else {
          autoQC = "No";
        }
      }
      if (permanentAddress && permanentAddress.addressLine1) {
        let finalLineAddressObj = getFinalAddressLines(addressObj);
        finalAddressLineforPermanent1 =
          finalLineAddressObj.finalAddressLineforPermanent1;
        finalAddressLineforPermanent2 =
          finalLineAddressObj.finalAddressLineforPermanent2;
        finalAddressLineforPermanent3 =
          finalLineAddressObj.finalAddressLineforPermanent3;
        finalAddressLineforPermanent4 =
          finalLineAddressObj.finalAddressLineforPermanent4;
      }
      if (sameAsPermanent) {
        finalAddressLineforCA1 = finalAddressLineforPermanent1
          ? finalAddressLineforPermanent1
          : "";
        finalAddressLineforCA2 = finalAddressLineforPermanent2
          ? finalAddressLineforPermanent2
          : "";
        finalAddressLineforCA3 = finalAddressLineforPermanent3
          ? finalAddressLineforPermanent3
          : "";
        finalAddressLineforCA4 = finalAddressLineforPermanent4
          ? finalAddressLineforPermanent4
          : "";
      } else if (corrspondenceAddress && corrspondenceAddress.addressLine1) {
        let finalLineAddressObj = getFinalAddressLines(corrspondenceAddress);
        finalAddressLineforCA1 =
          finalLineAddressObj.finalAddressLineforPermanent1;
        finalAddressLineforCA2 =
          finalLineAddressObj.finalAddressLineforPermanent2;
        finalAddressLineforCA3 =
          finalLineAddressObj.finalAddressLineforPermanent3;
        finalAddressLineforCA4 =
          finalLineAddressObj.finalAddressLineforPermanent4;
      }
    }

    let fileAttachements = [];
    if (addressObj.fileName && addressObj.fileData)
      fileAttachements.push({
        fileName: addressObj.fileName,
        fileData: addressObj.fileData,
        documentTypeName: addressObj.proof,
      });

    if (
      !sameAsPermanent &&
      corrspondenceAddress &&
      corrspondenceAddress.fileName &&
      corrspondenceAddress.fileData
    ) {
      fileAttachements.push({
        fileName: corrspondenceAddress.fileName,
        fileData: corrspondenceAddress.fileData,
        documentTypeName: corrspondenceAddress.proof,
      });
    }
    if (!props.childSr && kraDetails.webSign && kraDetails.panCard) {
      if (isEmptyObject(kraDetails.photo))
        fileAttachements.push({
          fileName: kraDetails.photo?.fileName,
          fileData: kraDetails.photo?.fileData,
          documentTypeName: kraDetails.photo?.documentTypeName,
        });
      else {
        if (permanentAddress.photoDetails && permanentAddress.pdfXMLResp) {
          fileAttachements = getAttachment(permanentAddress, fileAttachements)  
        } else {
          fileAttachements = getAttachment(addressObj, fileAttachements) 
        }
      }
      
      if (kraDetails.webSign)
        fileAttachements.push({
          fileName: kraDetails.webSign?.fileName,
          fileData: kraDetails.webSign?.fileData,
          documentTypeName: kraDetails.webSign?.documentTypeName,
        });
      if (kraDetails.panCard)
        fileAttachements.push({
          fileName: kraDetails.panCard?.fileName,
          fileData: kraDetails.panCard?.fileData,
          documentTypeName: kraDetails.panCard?.documentTypeName,
        });
        if (ipvcode && videoContent)
        fileAttachements.push({
          fileName: "videoIPV.webm",
          fileData: videoContent,
          documentTypeName: "IPV",
        });
    }else {
      if (permanentAddress.photoDetails && permanentAddress.pdfXMLResp) {
        fileAttachements = getAttachment(permanentAddress, fileAttachements)  
      } else {
        fileAttachements = getAttachment(addressObj, fileAttachements);
      }
    }
    let requestObj: any;
    if (srID) {
      var parentId = props.childSr
        ? digie && digie === "Yes"
          ? window.location.href.includes("rejected") ? true :  false
          : true
        : false;
      requestObj = [
        {
          serviceRequestId: srID,
          AutoQC: autoQC,
          ParentId: parentId,
          SRType: 'AddressChangeMode' ,
          is_digilocker_flow: addressObj.isDigiLocker
            ? addressObj.isDigiLocker
            : false,
          address_line_1: finalAddressLineforPermanent1,
          address_line_2: finalAddressLineforPermanent2,
          address_line_3: finalAddressLineforPermanent3,
          address_line_4: finalAddressLineforPermanent4,
          Corpaddress_line_1: finalAddressLineforCA1,
          Corpaddress_line_2: finalAddressLineforCA2,
          Coraddress_line_3: finalAddressLineforCA3,
          Coraddress_line_4: finalAddressLineforCA4,
          pincode: addressObj.pincode,
          city: addressObj.city,
          state: addressObj.stateStr,
          Corscity: sameAsPermanent
            ? addressObj.city
            : corrspondenceAddress.city,
          Corsstate: sameAsPermanent
            ? addressObj.stateStr
            : corrspondenceAddress.stateStr,
          Corspincode: sameAsPermanent
            ? addressObj.pincode
            : corrspondenceAddress.pincode,
          attachment:
            fileAttachements && fileAttachements.length > 0
              ? fileAttachements
              : null,
        },
      ];
    } else {
      requestObj = {
        requestType: "Address Modification",
        dpID: await getDepositoryDet(),
        is_digilocker_flow: addressObj.isDigiLocker,
        OldPeraddress_line_1: existingPermanentAddress.AddressLine1,
        OldPeraddress_line_2: existingPermanentAddress.AddressLine2,
        OldPeraddress_line_3: existingPermanentAddress.AddressLine3,
        OldPeraddress_line_4: existingPermanentAddress.AddressLine4,
        OldCorpaddress_line_1: existingCorrspondenceAddress.AddressLine1,
        OldCorpaddress_line_2: existingCorrspondenceAddress.AddressLine2,
        OldCorpaddress_line_3: existingCorrspondenceAddress.AddressLine3,
        OldCorpaddress_line_4: existingCorrspondenceAddress.AddressLine4,
        OldPerpincode: existingPermanentAddress.PinCode,
        OldPercity: existingPermanentAddress.City,
        OldPerstate: existingPermanentAddress.State,
        OldCorscity: existingCorrspondenceAddress.City,
        OldCorsstate: existingCorrspondenceAddress.State,
        OldCorspincode: existingCorrspondenceAddress.PinCode,
        address_line_1: finalAddressLineforPermanent1,
        address_line_2: finalAddressLineforPermanent2,
        address_line_3: finalAddressLineforPermanent3,
        address_line_4: finalAddressLineforPermanent4,
        Corpaddress_line_1: finalAddressLineforCA1,
        Corpaddress_line_2: finalAddressLineforCA2,
        Coraddress_line_3: finalAddressLineforCA3,
        Coraddress_line_4: finalAddressLineforCA4,
        pincode: addressObj.pincode,
        city: addressObj.city,
        state: addressObj.stateStr,
        Corscity: sameAsPermanent ? addressObj.city : corrspondenceAddress.city,
        Corspincode: sameAsPermanent
          ? addressObj.pincode
          : corrspondenceAddress.pincode,
        Corsstate: sameAsPermanent
          ? addressObj.stateStr
          : corrspondenceAddress.stateStr,
        AutoQC: autoQC,
        ipv_code: ipvcode? ipvcode : "",
        fileAttaches: fileAttachements,
      };
    }

    props.setLoader(true);
    setShowFinalAddress(true);
    setViewAddressSame(false);
    //  setQCStatus("Verified");props.setLoader(false);
    try {
      let reqObj;
      if (props.childSr) {
        if (digie && digie === "Yes") {
        } else {
          requestObj.AutoQC = "No";
        }
        if (srID) {
          delete requestObj.requestType;
          if (digie && digie === "Yes") {
            reqObj = requestObj;
          } else {
            delete requestObj.fileAttaches;
            requestObj[0].AutoQC = "No";
            requestObj[0].attachment = [];
            reqObj = requestObj;
          }
        } else {
          delete requestObj.fileAttaches;
          reqObj = {
            ...requestObj,
            parent_id: props.srId,
            requestType: "ADDRESSDETAILS",
          };
        }
      }

      let createSRRes: any;
      if (srID ) {
        createSRRes = await createSRDocumentUpload(
          props.childSr ? reqObj : requestObj
        );
        if (
          createSRRes &&
          (createSRRes === "All SR Details Updated successfully." ||
            createSRRes === "Child SR Details Updated successfully." || createSRRes === "Digilocker Flow of Address details updated successfully.")
        ) {

          if (props.childSr) {
            if (props.ckycStatus && digie && digie === "Yes") {
              //rejection flow in reactivation with digilocker
              let reqObj: any = [
                {
                  serviceRequestId: Number(props.ckycId),
                  AutoQC: "No",
                  SRType: "CKYCResubmitDigie",
                  attachment: [
                    {
                      fileName: addressObj.fileName,
                      fileData: addressObj.fileData,
                      documentTypeName: "Aadhar",
                    },
                    {
                      fileName: "DigiLocker_Photo1.jpg",
                      fileData: addressObj.photoDetails
                        ? addressObj.photoDetails
                        : permanentAddress.photoDetails,
                      documentTypeName: "ProfilePhoto",
                    },
                    {
                      fileName: "Adderss_PDF_XML.xml",
                      fileData: addressObj.pdfXMLResp
                        ? addressObj.pdfXMLResp
                        : permanentAddress.pdfXMLResp,
                      documentTypeName: "AadhaarXML",
                    },
                  ],
                },
              ];
              let resp = await createSRDocumentUpload(reqObj);
            }
            props.next();
            return;
          }
        }
      } else {
        if (props.childSr) {
          createSRRes = await CreateChildServiceRequestDetails(reqObj);
          localStorage.removeItem("personalDetails");
          
        } else {
          createSRRes = await CreateServiceRequestDetails(requestObj);
        }
      }
      if (
        typeof createSRRes === "string" &&
        createSRRes.includes("Previous Request already open for this account-")
      ) {
        openExistSrPopup();
        return;
      } else {
        if (createSRRes === "All SR Details Updated successfully.") {
          setShowFinalAddress(true);
          setSerReqId(srID);
          const prefillFormpdfRes = await esignService.getPreFilledFormPDF(
            srID,
            "address"
          );
          if (prefillFormpdfRes !== null) {
            setPrefilledBase64(prefillFormpdfRes);
          }
          props.setLoader(false);
        } else if (createSRRes && createSRRes.Message) {
          setShowFinalAddress(true);
          setSerReqId(createSRRes.Id);
          if (soad && soad === "dig" && !props.childSR) {
            if (permanentAddress.autoQc === "Yes") {
              let result: any = await esignService.proceedToEsign(
                createSRRes.Id,
                "address",
                true
              );
              if (!result) openErrorPopup();
            } else if(createSRRes.Message == "We have received your request for changing your address. This request will be processed in 2-3 business days."){
              let esignSuccess = await esignService.proceedToEsign(createSRRes.Id,"address", true);
              if(esignSuccess){
                let prefillFormpdfRes = await esignService.getPreFilledFormPDF(createSRRes.Id, "address");
                if (prefillFormpdfRes) {
                  esignService.base64toPDF(prefillFormpdfRes);
                }
              }
            } else {
              const prefillFormpdfRes = await esignService.getPreFilledFormPDF(
                createSRRes.Id,
                "address"
              );
              if (prefillFormpdfRes !== null) {
                setPrefilledBase64(prefillFormpdfRes);
              }
              setCheckAutoQcFlag(
                setInterval(async () => {
                  let serviceReqList = await asyncGetServiceRequest();

                  if (
                    serviceReqList.filter((ele: any) => {
                      return ele.RequestId == createSRRes.Id;
                    })[0].RequestStatus === "PendingForEsign"
                  ) {
                    setQCStatus("Verified");
                    setEnableEsign(true);
                  }
                }, 10000)
              );
              props.setLoader(false);
            }
          } else if (props.childSr && digie) {
            if (digie === "Yes") {
              let reqObj: any = [
                {
                  serviceRequestId: createSRRes.Id,
                  AutoQC: permanentAddress.autoQC,
                  SRType: "Address Digilocker",
                  attachment: [
                    {
                      fileName: addressObj.fileName,
                      fileData: addressObj.fileData,
                      documentTypeName: "Aadhar",
                    },
                    {
                      fileName: "DigiLocker_Photo1.jpg",
                      fileData: addressObj.photoDetails
                        ? addressObj.photoDetails
                        : permanentAddress.photoDetails,
                      documentTypeName: "ProfilePhoto",
                    },
                    {
                      fileName: "Adderss_PDF_XML.xml",
                      fileData: addressObj.pdfXMLResp
                        ? addressObj.pdfXMLResp
                        : permanentAddress.pdfXMLResp,
                      documentTypeName: "AadhaarXML",
                    },
                  ],
                },
              ];

              if (
                parentDetails?.dormant_type.includes("6") &&
                !props.ckycStatus
              ) {
                reqObj[0].SRType = "AddressDigilockerDormantMode";
                reqObj.unshift({
                  serviceRequestId: Number(props.srId),
                  attachment: null,
                  SRType: "ParentWithSR",
                });
              }

              let resp = await createSRDocumentUpload(reqObj);
              if (
                resp &&
                (resp ===
                  "Digilocker Flow of Address details updated successfully." ||
                  resp === "Document uploaded successfully.")
              ) {
                props.next();
                return;
              }
            } else {
              props.next();
              return;
            }
          } else {
            if (props.childSr) {
              props.next();
              return;
            }
            if(createSRRes.Message == "We have received your request for changing your address. This request will be processed in 2-3 business days."){
              let esignSuccess = await esignService.proceedToEsign(createSRRes.Id,"address", true);
              if(esignSuccess){
                let prefillFormpdfRes = await esignService.getPreFilledFormPDF(createSRRes.Id, "address");
                if (prefillFormpdfRes) {
                  esignService.base64toPDF(prefillFormpdfRes);
                }
              }
            } else {
              setShowFinalAddress(true);
              const prefillFormpdfRes = await esignService.getPreFilledFormPDF(
                createSRRes.Id,
                "address"
              );
              if (prefillFormpdfRes !== null) {
                setPrefilledBase64(prefillFormpdfRes);
              }
              props.setLoader(false);
              setCheckAutoQcFlag(
                setInterval(async () => {
                  let serviceReqList = await asyncGetServiceRequest();

                  if (
                    serviceReqList.filter((ele: any) => {
                      return ele.RequestId == createSRRes.Id;
                    })[0].RequestStatus === "PendingForEsign"
                  ) {
                    setQCStatus("Verified");
                    setEnableEsign(true);
                  }
                }, 10000)
              );
            }
          }
        } else openSRErrorPopup();
      }
    } catch (error) {
      console.log("ERrror", error);
      // openSRErrorPopup();
      localStorage.removeItem("personalDetails");
      localStorage.removeItem("digiAuthToken");
      localStorage.removeItem("digiAuthKey");
      localStorage.removeItem("digiLockerToken");
      localStorage.removeItem("ipvcode");
      localStorage.removeItem("DormantMoreThanYear");
      localStorage.removeItem("imageData");
      localStorage.removeItem("ipvcode");
      localStorage.removeItem("latitude");
      localStorage.removeItem("longitude");
    }
  }
  function setDigilockerFlag() {
    if (enableDigilocker) {
      setEnableDigilocker(false);
    } else {
      setEnableDigilocker(true);
    }
  }
  function getAddressString(address: any) {
    let addressStr = "";
    if (address) {
      if (address.addressLine1) {
        addressStr = addressStr.concat(address.addressLine1).concat(", ");
      }
      if (address.addressLine2) {
        addressStr = addressStr.concat(address.addressLine2).concat(", ");
      }
      if (address.addressLine3) {
        addressStr = addressStr.concat(address.addressLine3).concat(", ");
      }
      if (address.addressLine4) {
        addressStr = addressStr.concat(address.addressLine4).concat(", ");
      }
      if (address.stateStr) {
        addressStr = addressStr.concat(address.stateStr).concat(", ");
      }
      if (address.city) {
        addressStr = addressStr.concat(address.city).concat(", ");
      }
      if (address.pincode) {
        addressStr = addressStr.concat(address.pincode).concat(" ");
      }
    }
    return addressStr;
  }
  const openSRErrorPopup = () => {
    props.setLoader(false);
    props.onSubmit("addressModification", {
      headerText:
        "There was some problem in raising service request. Please try again later.",
    });
  };
  const openErrorPopup = () => {
    props.setLoader(false);
    props.onSubmit("addressModification", {
      headerText: "There was some error while proceeding with esign process.",
    });
  };
  const openSRSuccessPopup = (createSRRes: any) => {
    props.setLoader(false);
    let paramObj: any = {
      headerText: "We have received your request!",
      content: invOnlyAcc ? "We have received your request. Status of your request will be communicated through email": "Your request will be updated within TWO working days. Status of your request will be communicated through Email",
      popupType: "Success"
    };

    if(createSRRes.Data.refId){
      paramObj.btnText = "Download E-Signed Form";
      paramObj.refId = createSRRes.Data.refId;
    }
    props.onSubmit("address", paramObj);
  };
  const openExistSrPopup = () => {
    props.setLoader(false);
    props.onSubmit("addressModification", {
      headerText: "You have an active service request",
      content:
        "You already have an active service request. Once it is updated, you will be able to raise new request.",
    });
    return;
  };
  const getDigiLockerUrl = async () => {
    let reqObj: any = {};
    reqObj.reDirectUrl = config.reDirectUrl;
  //  reqObj.reDirectUrl = "http://localhost:3001/showDocuments"
    reqObj.reDirectTime = "3";
    let resp = await fetchDigiLockerUrl(reqObj);
    if(resp) {
      localStorage.setItem("digiLockerToken",resp?.data[0]?.Token);
      localStorage.setItem("digiAuthToken",resp?.authToken);
      localStorage.setItem("digiAuthKey",resp?.authKey);
      localStorage.removeItem("DormantMoreThanYear");
      localStorage.removeItem("ipvcode");
      localStorage.removeItem("imageData");
      setShowRevalidateAddress(false);
      window.location.href = resp?.data[0]?.Link;
    }
  }
  const isAccClouserOpen = serviceReqListArr?.length && serviceReqListArr.find((item:any) =>
    item.RequestType === 'Online Closure' && (item.RequestStatus === 'EsignSubmitted' || item.RequestStatus === 'Assigned' || item.RequestStatus === 'Open' || item.RequestStatus === 'PendingForEsign')
  );
  return (
    <>
    {props.loader ? null : !isAccClouserOpen ? (nameDOBValidation && nameDOBValidation == "success") ? 
    (
    <div className="addressModifyWrap">
      {!props.loader && !existingAddressSR && !showIpvScreen && (
        <> {/* condition to be changed if ipv not to be shown for standalone address sr */}
        { showPrerequisiteLink && <div className="editAddress view-prerequisite mg-b10"> 
           <a 
           onMouseOver={() => setshowPrerequisites(true) }  
           onMouseOut ={() => setshowPrerequisites(false) }
           className="field-subHead bold-text blue-text editAdd">
                            View Prerequisites
            </a>
        </div>}  
                        
         <p className="add-text bold-text">Please do not refresh the page or use back button</p>
          {viewAddress && (
            <div>
              <div className="addressModify">
                <div className={ViewAddressSame ? "address-1" : "address"}>
                  <div>
                    <div className="address-headBlock">
                      <h6 className="field-subHead bold-text">
                        Permanent {ViewAddressSame ? "and Correspondence" : ""}{" "}
                        Address
                      </h6>
                      {!showFinalAddress && !soad && !(dormantMoreThanYear == 'true') && (
                        <div className="editAddress">
                          <a
                            onClick={() => {
                              {
                                setshowEditAddressOptions(true);
                                setViewAddress(false);
                                setShowPrerequisiteLink(false);
                              }
                            }}
                            className="field-subHead bold-text blue-text editAdd"
                          >
                            Edit Address
                          </a>
                        </div>
                      )}
                    </div>

                    {permanentAddress && (
                      <p className="addText">
                        {getAddressString(permanentAddress)
                          ? getAddressString(permanentAddress)
                          : ""}
                      </p>
                    )}
                  </div>
                  {!showFinalAddress && !ViewAddressSame && (
                    <div className="space-mt-2">
                      {!soad && (
                        <h6 className="field-subHead bold-text">
                          Correspondence Address
                        </h6>
                      )}
                      {soad && soad === "dig" && sameAsPermanent && (
                        <h6 className="field-subHead bold-text">
                          Correspondence Address same as Permanent Address
                        </h6>
                      )}

                      {corrspondenceAddress && (
                        <p className="addText">
                          {getAddressString(corrspondenceAddress)
                            ? getAddressString(corrspondenceAddress)
                            : ""}
                        </p>
                      )}
                    </div>
                  )}
                  {showFinalAddress && !sameAsPermanent && (
                    <div className="space-mt-2">
                      <h6 className="field-subHead bold-text">
                        Correspondence Address
                      </h6>

                      {corrspondenceAddress && (
                        <p className="field-subHead-corr-address addText">
                          {getAddressString(corrspondenceAddress)
                            ? getAddressString(corrspondenceAddress)
                            : ""}
                        </p>
                      )}
                    </div>
                  )}
                  {showFinalAddress && sameAsPermanent && (
                    <div className="space-mt-2 sameAddr">
                      <h6 className="field-subHead bold-text">
                        Correspondence Address same as Permanent Address
                      </h6>
                    </div>
                  )}
                </div>
                { showPrerequisites && <div className="prerequisite-box">
                  <p className="bold-text font-14">Prerequisites for Reactivation with Address Modification</p>
                     <ul>
                       <li>Acceptable documents in case of Address Modification includes Driving License, NREGA Job Card, Passport, or Voter ID. Also, a copy of your Pan Card, a wet signature, and a photograph must be uploaded.</li>
                       <li>You will need to perform a video IPV. Please ensure you have white paper and a pen ready. </li>
                       <li>E-Sign is mandatory for both Digi locker and Non-Digi locker flows. Have your Aadhaar number ready.</li>
                     </ul>
                </div> }
                {((dormantMoreThanYear == 'true') && showRevalidateAddress) && <div className="addr-revalidate">
                  <div>Revalidate your address</div>
                <button
                      type="button"
                      className=" common_button block_btn addr-revalidate-btn"
                      onClick={async () => {
                        //if (!props.childSr) {
                         if (showFinalAddress) {
                            setshowEditAddressOptions(false);
                            props.setLoader(true);
                            setViewAddress(true);
                            submitRequest();
                          } else {
                            setshowEditAddressOptions(true);
                            setViewAddress(false);
                            setShowPrerequisiteLink(false);
                          }
                          if (serReqId && prefilledBase64) {
                            esignService.getEsignUrl(
                              prefilledBase64,
                              serReqId,
                              "address"
                            );
                          }
                        //} 
                        // else {
                        //   submitRequest();
                        // }
                        setShowRevalidateAddress(false);
                        setShowPrerequisiteLink(false);
                      }}>Revalidate Address</button>
                </div>}
              </div>
              {!showFinalAddress &&
                !props.childSr &&
                soad &&
                soad === "dig" &&
                sameAsPermanent && (
                  <KRADocumentUploadForm
                    kraDetails={kraDetails}
                    setKraDetails={setKraDetails}
                    hidePhoto={true}
                  ></KRADocumentUploadForm>
                )}
              {showFinalAddress && !props.childSr && (
                <>
                  <div className="display-flex custom-row confirmAdddressPage">
                    <div className=" form-field custom-col-1">
                      <label className="field-subHead bold-text field-subHead-corr-address">
                        Permanent Address Proof
                      </label>
                      {permanentAddress && !permanentAddress.imgSrc && (
                        <span>
                          {permanentAddress && permanentAddress.fileName && (
                            <div
                              className={
                                (soad && soad === "dig") ||
                                !permanentAddress.imgSrc
                                  ? "display-flex field-subHead"
                                  : ""
                              }
                            >
                              {((soad && soad === "dig") ||
                                !permanentAddress.imgSrc) && (
                                <div>
                                  <img
                                    src={pdf_icon}
                                    height="50px"
                                    width="50px"
                                  />
                                </div>
                              )}
                              <p
                                className={
                                  (soad && soad === "dig") ||
                                  !permanentAddress.imgSrc
                                    ? "bankcheckbox-left"
                                    : "field-subHead"
                                }
                              >
                                {permanentAddress.fileName}
                              </p>
                            </div>
                          )}
                          {/* {permanentAddress &&
                            permanentAddress.fileName &&
                            qcStatus === "Verification in Process" && (
                              <p className="field-subHead qc_status_color">
                                {qcStatus}
                              </p>
                            )}
                          {permanentAddress &&
                            permanentAddress.fileName &&
                            qcStatus === "Verified" && (
                              <p className="field-subHead text-indicator ">
                                {qcStatus}
                              </p>
                            )} */}
                        </span>
                      )}
                      {permanentAddress && permanentAddress.imgSrc && (
                        <div className="custom-row display-flex docWrap field-subHead">
                          {permanentAddress && permanentAddress.imgSrc && (
                            <img
                              src={permanentAddress.imgSrc}
                              height="50px"
                              width="40px"
                              className="m105"
                            />
                          )}
                          {permanentAddress && permanentAddress.imgSrc2 && (
                            <img
                              src={permanentAddress.imgSrc2}
                              height="50px"
                              width="40px"
                              className="ml05"
                            />
                          )}
                           {permanentAddress &&
                                permanentAddress.fileName && (
                                  <p className="field-subHead field-subHead-address">
                                    {permanentAddress.fileName}
                                  </p>
                                )}
                        </div>
                      )}
                    </div>
                    {!sameAsPermanent && (
                      <div className=" form-field custom-col-1">
                        <label className="field-subHead bold-text field-subHead-corr-address">
                          Correspondence Address Proof
                        </label>
                        {corrspondenceAddress &&
                          !corrspondenceAddress.imgSrc && (
                            <span>
                              {corrspondenceAddress &&
                                corrspondenceAddress.fileName && (
                                  <>
                                    <div
                                      className={
                                        !corrspondenceAddress.imgSrc
                                          ? "display-flex field-subHead"
                                          : ""
                                      }
                                    >
                                      {!corrspondenceAddress.imgSrc && (
                                        <div>
                                          <img
                                            src={pdf_icon}
                                            height="50px"
                                            width="50px"
                                          />
                                        </div>
                                      )}
                                      <p
                                        className={
                                          !corrspondenceAddress.imgSrc
                                            ? "bankcheckbox-left"
                                            : "field-subHead"
                                        }
                                      >
                                        {corrspondenceAddress.fileName}
                                      </p>
                                    </div>
                                  </>
                                )}
                            </span>
                          )}
                        {corrspondenceAddress &&
                          corrspondenceAddress.imgSrc && (
                            <div className="custom-row display-flex docWrap">
                              {corrspondenceAddress &&
                                corrspondenceAddress.imgSrc && (
                                  <img
                                    src={corrspondenceAddress.imgSrc}
                                    height="50px"
                                    width="40px"
                                  />
                                )}
                              {corrspondenceAddress &&
                                corrspondenceAddress.imgSrc2 && (
                                  <img
                                    src={corrspondenceAddress.imgSrc2}
                                    height="50px"
                                    width="40px"
                                    className="ml05"
                                  />
                                )}
                              <div className="custom-row-1">
                                <span>
                                  {corrspondenceAddress &&
                                    corrspondenceAddress.fileName && (
                                      <p className="field-subHead field-subHead-address">
                                        {corrspondenceAddress.fileName}
                                      </p>
                                    )}
                                </span>
                              </div>
                            </div>
                          )}
                      </div>
                    )}

                    {sameAsPermanent && (
                      <div className=" form-field custom-col-1">
                          <ViewKRADocuments
                            document={kraDetails.webSign}
                            title={"Signature"}
                          ></ViewKRADocuments>
                      </div>
                    )}
                  </div>
                  {kraDetails && (
                    <>
                      {sameAsPermanent  ? 
                        <>
                        <div className="display-flex custom-row confirmAdddressPage">
                        <div className=" form-field custom-col-1">
                          <ViewKRADocuments
                            document={kraDetails.panCard}
                            title={"PAN Card Copy"}
                          ></ViewKRADocuments>
                        </div>
                        <div className=" form-field custom-col-1">
                          <ViewKRADocuments
                            document={
                              isEmptyObject(kraDetails.photo)
                                ? kraDetails.photo
                                : {
                                    imgSrc:
                                      "data:image/jpg;base64," +
                                      permanentAddress.photoDetails,
                                    fileName: "Digilocker_photo.jpg",
                                  }
                            }
                            title={"Photo"}
                          ></ViewKRADocuments>
                        </div>
                      </div>
                        </>
                          :
                          <>
                           <div className="display-flex custom-row confirmAdddressPage">
                          <div className=" form-field custom-col-1">
                          <ViewKRADocuments
                            document={kraDetails.webSign}
                            title={"Signature"}
                          ></ViewKRADocuments>
                        </div>
                        <div className=" form-field custom-col-1">
                          <ViewKRADocuments
                            document={kraDetails.panCard}
                            title={"PAN Card Copy"}
                          ></ViewKRADocuments>
                        </div>
                        </div>
                        <div className="display-flex custom-row confirmAdddressPage">
                        <div className=" form-field custom-col-1">
                          <ViewKRADocuments
                            document={
                              isEmptyObject(kraDetails.photo)
                                ? kraDetails.photo
                                : {
                                    imgSrc:
                                      "data:image/jpg;base64," +
                                      permanentAddress.photoDetails,
                                    fileName: "Digilocker_photo.jpg",
                                  }
                            }
                            title={"Photo"}
                          ></ViewKRADocuments>
                        </div>
                      </div>
                          </>
                          }
                    </>
                  )}
                  <div>
                    <div className="space-mt-2">
                      <Checkbox checked={userConsent}
                        onChange={async () => { setUserConsent(!userConsent) }}
                        name="UserConsent"
                      >
                        <span className="font-14 bold-text warm-grey-eight-text">I further confirm that below points verified by self</span>           
                      </Checkbox>
                    </div>
                    <ul className="circle-list marker-mg-r10 font-RobotoCR">
                      <div className="pd-l45">
                        <li className="font-18 pinkish-grey-five-color"><span className="font-12 warm-grey-eight-text">Please upload the colour image of document directly taken from the original document.</span></li>
                        <li className="font-18 pinkish-grey-five-color"><span className="font-12 warm-grey-eight-text">Please check the validity of document in case of Passport and Driving Licence.</span></li>
                      </div>
                    </ul>
                  </div>
                </>
              )}
            </div>
          )}
          {showWithoutDigilocker && (
            <>
              <div id="Permanent_address" className="display-flex">
                <h6 className="field-subHead bold-text">Permanent Address</h6>
              </div>
              <AddressModificationForm
                addressObj={permanentAddress}
                secondAddress={corrspondenceAddress}
                textHeadName={"Permanent"}
                setAddressObj={(obj: any) => {
                  if (sameAsPermanent) setCorrspondenceAddress(obj);
                  setPermanentAddress(obj);
                }}
                disabledButton={setDisabledButton}
                areas={areaOptions}
                accountCode={accountCode}
                sameAsPermanent={sameAsPermanent}
                childSr={props.childSr}
                dpType={dpType}
                kraDetails={kraDetails}
                addessType = {addrType}
              ></AddressModificationForm>

              <div className="CheckboxWrapSec">
                <div className="display-flex custom-row CheckboxWrap">
                  <div className=" form-field custom-col-1">
                    <h6 className="field-subHead bold-text">
                      Correspondence Address
                    </h6>
                  </div>
                  <div className=" form-field custom-col permanentAddrCheckbox">
                    <div className="display-flex">
                      <Checkbox
                        checked={sameAsPermanent}
                        name="consent"
                        onChange={() => {
                          setAddressFlag();
                        }}
                      >
                        <span className="incomeMsg regular-font declare">
                          {" "}
                          Same as Permanent Address{" "}
                        </span>
                      </Checkbox>
                    </div>
                  </div>
                </div>
                <div className="CheckboxWrap-fields">
                  {!sameAsPermanent && (
                    <AddressModificationForm
                      addressObj={corrspondenceAddress}
                      textHeadName={"Correspondence"}
                      secondAddress={permanentAddress}
                      setAddressObj={setCorrspondenceAddress}
                      disabledButton={setDisabledButton}
                      areas={
                        srID && areaCOOptions ? areaCOOptions : areaOptions
                      }
                      accountCode={accountCode}
                      sameAsPermanent={sameAsPermanent}
                      childSr={props.childSr}
                      dpType={dpType}
                      kraDetails={kraDetails}
                      addessType = {addrType}
                    ></AddressModificationForm>
                  )}
                </div>
              </div>
              {!props.childSr && (
                <KRADocumentUploadForm
                  kraDetails={kraDetails}
                  setKraDetails={setKraDetails}
                ></KRADocumentUploadForm>
              )}
            </>
          )}

          {showEditAddressOptions && (
            <div>
              <div className="">
                <div className="image">
                  <img
                    src={digiLocker_img}
                    alt="Aadhaar via DigiLocker"
                    className="received-request-img"
                  />
                </div>
              </div>
              <div>
                <h5 className="field-head text-center head">
                  Requesting your Aadhaar via DigiLocker
                </h5>
                <p className="small-text small-text--subHead">
                  DigiLocker is a Govt. of India initiative, allowing us to get
                  an authorized digital copy of your Aadhaar card which can be
                  used as an Address Proof.
                </p>
              </div>
              <div className="reactivateSteps">
                <p className="small-text">Steps to follow</p>
                <ul>
                  <li className="bullet_lists">
                    <div>
                      <div className="link_arrow">
                        <i className="edel-icon-right-arrow"></i>
                      </div>
                    </div>
                    <p className="small-text-bulletlist">
                      Login or Register on DigiLocker using your Mobile No. and
                      OTP
                    </p>
                  </li>
                  <li className="bullet_lists">
                    <div>
                      <div className="link_arrow">
                        <i className="edel-icon-right-arrow"></i>
                      </div>
                    </div>
                    <p className="small-text-bulletlist">
                      Enter your security PIN
                    </p>
                  </li>
                  <li className="bullet_lists">
                    <div>
                      <div className="link_arrow">
                        <i className="edel-icon-right-arrow"></i>
                      </div>
                    </div>
                    <p className="small-text-bulletlist">
                      Provide consent to share your Aadhaar with Nuvama
                    </p>
                  </li>
                  <li className="bullet_lists">
                    <div>
                      <div className="link_arrow">
                        <i className="edel-icon-right-arrow"></i>
                      </div>
                    </div>
                    <p className="small-text-bulletlist">
                      Once done you will be brought back here to continue with
                      your reactivation
                    </p>
                  </li>
                </ul>
                <p className="text-center note">
                  <span>Please note: </span>Your Mobile No. needs to be linked
                  to your Aadhaar
                </p>
                <div className="display-flex declarationWrap">
                  <Checkbox
                    checked={enableDigilocker}
                    name="consent"
                    onChange={setDigilockerFlag}
                  >
                    {invOnlyAcc && (
                            <span className="incomeMsg regular-font declare">
                              I voluntarily authorize DigiLocker to share my Aadhaar 
                              details for changing address in my Investment Account 
                              with Nuvama Wealth and Investment Ltd.
                            </span>
                          )}
                          {!invOnlyAcc && (
                            <span className="incomeMsg regular-font declare">
                              I voluntarily authorize DigiLocker to share my Aadhaar
                              details for changing address in my Demat and Trading
                              account with Nuvama Wealth and Investment Ltd.
                            </span>
                          )}
                  </Checkbox>
                </div>
                <div className="">
                  {!enableDigilocker && (
                    <button
                      type="button"
                      className=" common_button block_btn light-text"
                      disabled={!enableDigilocker}
                      onClick={() => {
                        if (enableDigilocker) {
                          if (source && source === "ajs")
                            window.localStorage.setItem("source", source);
                          if (props.childSr) {
                            localStorage.setItem("digie", "Yes");
                          }
                          setshowEditAddressOptions(false);
                          window.location.href = dgLockerLinkUrl;
                        }
                      }}
                    >
                      Connect To Digilocker
                    </button>
                  )}
                  {enableDigilocker && (
                    <button
                      type="button"
                      className=" common_button block_btn"
                      disabled={!enableDigilocker}
                      onClick={() => {
                        if (enableDigilocker) {
                          setshowEditAddressOptions(false);
                          if (srID) {
                            window.localStorage.setItem("srId", srID);
                          }
                          if (source && source === "ajs")
                            window.localStorage.setItem("source", source);
                          if (props.childSr) {
                            localStorage.setItem("digie", "Yes");
                            if (consentType) {
                              localStorage.setItem("consentType", consentType);
                            }
                            if (addressConsent) {
                              localStorage.setItem("consent", addressConsent);
                            }
                            if (srID) {
                              localStorage.setItem("rejectFlow", "Yes");
                            }
                          }
                          getDigiLockerUrl();
                          //window.location.href = dgLockerLinkUrl;
                          //  window.location.href = config.root + "showDocuments";
                          props.setLoader(true);
                        }
                      }}
                    >
                      Connect To Digilocker
                    </button>
                  )}
                </div>
                <a
                  onClick={() => {
                    {
                      setshowEditAddressOptions(false);
                      setshowWithoutDigilocker(true);
                      (
                        document.getElementsByClassName(
                          "modal-Sr"
                        )[0] as HTMLDivElement
                      ).scrollTo({
                        top: 0,
                        left: 0,
                        behavior: "smooth",
                      });
                    }
                    localStorage.removeItem("digiAuthToken");
                    localStorage.removeItem("digiAuthKey");
                    localStorage.removeItem("digiLockerToken");
                    setShowPrerequisiteLink(false);
                  }}
                  className="blue-text bold-text"
                >
                  Continue Without Digilocker *
                </a>
                <p className="continueDigiProcess">
                  {" "}
                  * If you want to enter a different permanent and
                  correspondence address or your mobile and Aadhar are not
                  linked, please continue without digilocker process
                </p>
                <div className="text"></div>
              </div>
            </div>
          )}

          {!showEditAddressOptions && (
            <div
              className={
                props.childSr
                  ? viewAddress
                    ? "modal-footer common-modal--footer addressFooterForViewSR"
                    : "modal-footer common-modal--footer addressFooterForSR"
                  : "modal-footer common-modal--footer addressFooter"
              }
            >
              {viewAddress && !showFinalAddress && props.childSr && (
                <>
                  <button
                    type="button"
                    className="btn btn-blue login-btn"
                    disabled={!props.childSr || !invAddress || (dormantMoreThanYear == 'true')}
                    onClick={() => {
                      if (props.childSr) {
                        props.next();
                      }
                      setshowEditAddressOptions(true);
                      setViewAddress(false);
                    }}
                  >
                    Proceed
                  </button>
                  <button
                    type="submit"
                    disabled={
                      (consentType &&
                        (consentType?.includes("email") ||
                          consentType?.includes("mobile") ||
                          consentType?.includes("emailMob"))) ||
                      addressConsent?.includes("Change of Address")
                        ? true
                        : false
                    }
                    className="btn btn-olink btn-olink-address login-btn"
                  >
                    {!(
                      (consentType &&
                        (consentType?.includes("email") ||
                          consentType?.includes("mobile") ||
                          consentType?.includes("emailMob"))) ||
                      addressConsent?.includes("Change of Address")
                    ) && (
                      <a
                        className="btn btn-olink btn-olink-address login-btn "
                        href={
                          RedirectnSource == "onep-sr" 
                          ? config.onePlatformBase + "service-request" 
                          : config.rootUrl + "clientarea/servicerequest"
                        }
                        onClick={() => {
                          clearLocalStorage();
                        }}
                      >
                        Cancel
                      </a>
                    )}
                    {((consentType &&
                      (consentType?.includes("email") ||
                        consentType?.includes("mobile") ||
                        consentType?.includes("emailMob"))) ||
                      addressConsent?.includes("Change of Address")) && (
                      <label className="btn btn-olink login-btn">Cancel</label>
                    )}
                  </button>
                </>
              )}
              {viewAddress && showFinalAddress && props.childSr && (
                <div>
                  {" "}
                  {soad && soad === "dig" && (
                    <>
                      <button
                        type="button"
                        className="btn btn-blue login-btn"
                        disabled={
                          !sourceAddress || showFinalAddress
                            ? !enableEsign
                            : false
                        }
                        onClick={async () => {
                          if (!props.childSr) {
                            setshowEditAddressOptions(false);
                            setViewAddress(true);
                            if (soad && soad === "dig") {
                              if (!showFinalAddress) submitRequest();
                            } else if (serReqId && prefilledBase64) {
                              esignService.getEsignUrl(
                                prefilledBase64,
                                serReqId,
                                "address"
                              );
                            }
                          } else {
                            submitRequest();
                          }
                        }}
                      >
                        {props.childSr
                          ? "Proceed"
                          : permanentAddress.autoQC === "Yes"
                          ? "Confirm & E-Sign"
                          : "Submit"}
                      </button>
                      <button
                        type="submit"
                        disabled={
                          (consentType &&
                            (consentType?.includes("email") ||
                              consentType?.includes("mobile") ||
                              consentType?.includes("emailMob"))) ||
                          addressConsent?.includes("Change of Address")
                            ? true
                            : false
                        }
                        className="btn btn-olink btn-olink-address login-btn"
                      >
                        {!(
                          (consentType &&
                            (consentType?.includes("email") ||
                              consentType?.includes("mobile") ||
                              consentType?.includes("emailMob"))) ||
                          addressConsent?.includes("Change of Address")
                        ) && (
                          <a
                            className="btn btn-olink btn-olink-address login-btn "
                            href={
                              RedirectnSource == "onep-sr" 
                              ? config.onePlatformBase + "service-request" 
                              : config.rootUrl + "clientarea/servicerequest"
                            }
                            onClick={() => {
                              clearLocalStorage();
                            }}
                          >
                            Cancel
                          </a>
                        )}
                        {((consentType &&
                          (consentType?.includes("email") ||
                            consentType?.includes("mobile") ||
                            consentType?.includes("emailMob"))) ||
                          addressConsent?.includes("Change of Address")) && (
                          <label className="btn btn-olink login-btn">
                            Cancel
                          </label>
                        )}
                      </button>
                    </>
                  )}
                  {!(soad && soad === "dig") && (
                    <>
                      <button
                        type="button"
                        className="btn btn-blue login-btn"
                        disabled={props.childSr ? false : !enableEsign }
                        onClick={async () => {
                          if (!props.childSr) {
                            setshowEditAddressOptions(false);
                            setViewAddress(true);
                            if (serReqId && prefilledBase64) {
                              esignService.getEsignUrl(
                                prefilledBase64,
                                serReqId,
                                "address"
                              );
                            }
                          } else {
                            submitRequest();
                          }
                        }}
                      >
                        {props.childSr ? "Proceed" : "Confirm & E-Sign"}
                      </button>
                      <button
                        type="submit"
                        disabled={
                          (consentType &&
                            (consentType?.includes("email") ||
                              consentType?.includes("mobile") ||
                              consentType?.includes("emailMob"))) ||
                          addressConsent?.includes("Change of Address")
                            ? true
                            : false
                        }
                        className="btn btn-olink btn-olink-address login-btn"
                      >
                        {!(
                          (consentType &&
                            (consentType?.includes("email") ||
                              consentType?.includes("mobile") ||
                              consentType?.includes("emailMob"))) ||
                          addressConsent?.includes("Change of Address")
                        ) && (
                          <a
                            className="btn btn-olink btn-olink-address login-btn "
                            href={
                              RedirectnSource == "onep-sr" 
                              ? config.onePlatformBase + "service-request" 
                              : config.rootUrl + "clientarea/servicerequest"
                            }
                            onClick={() => {
                              clearLocalStorage();
                            }}
                          >
                            Cancel
                          </a>
                        )}
                        {((consentType &&
                          (consentType?.includes("email") ||
                            consentType?.includes("mobile") ||
                            consentType?.includes("emailMob"))) ||
                          addressConsent?.includes("Change of Address")) && (
                          <label className="btn btn-olink login-btn">
                            Cancel
                          </label>
                        )}
                      </button>
                    </>
                  )}
                </div>
              )}
              {viewAddress && (
                <div>
                  {" "}
                  {soad && soad === "dig" && (
                    <>
                      <button
                        type="button"
                        className="btn btn-blue login-btn"
                        disabled={
                          showFinalAddress
                            ? (userConsent ? false : true)
                            : !disabledButton
                        }
                        onClick={async () => {
                          if (!props.childSr) {
                            setshowEditAddressOptions(false);
                            setViewAddress(true);
                            if (soad && soad === "dig") {
                              if (showFinalAddress) submitRequest();
                              else{
                                setShowFinalAddress(true);
                              }
                            } else if (serReqId && prefilledBase64) {
                              esignService.getEsignUrl(
                                prefilledBase64,
                                serReqId,
                                "address"
                              );
                            } 
                          } else {
                            submitRequest();
                          }
                        }}
                      >
                        {props.childSr
                          ? "Proceed"
                          : permanentAddress.autoQC === "Yes"
                          ? "Confirm & E-Sign"
                          : showFinalAddress
                          ? "Confirm & E-Sign"
                          : "Submit"}
                      </button>
                      <button
                        type="submit"
                        disabled={
                          (consentType &&
                            (consentType?.includes("email") ||
                              consentType?.includes("mobile") ||
                              consentType?.includes("emailMob"))) ||
                          addressConsent?.includes("Change of Address")
                            ? true
                            : false
                        }
                        className="btn btn-olink btn-olink-address login-btn"
                      >
                        {!(
                          (consentType &&
                            (consentType?.includes("email") ||
                              consentType?.includes("mobile") ||
                              consentType?.includes("emailMob"))) ||
                          addressConsent?.includes("Change of Address")
                        ) && (
                          <a
                            className="btn btn-olink btn-olink-address login-btn "
                            href={
                              RedirectnSource == "onep-sr" 
                              ? config.onePlatformBase + "service-request" 
                              : config.rootUrl + "clientarea/servicerequest"
                            }
                            onClick={() => {
                              clearLocalStorage();
                            }}
                          >
                            Cancel
                          </a>
                        )}
                        {((consentType &&
                          (consentType?.includes("email") ||
                            consentType?.includes("mobile") ||
                            consentType?.includes("emailMob"))) ||
                          addressConsent?.includes("Change of Address")) && (
                          <label className="btn btn-olink login-btn">
                            Cancel
                          </label>
                        )}
                      </button>
                    </>
                  )}
                  {!(soad && soad === "dig") &&
                    ((viewAddress && !showFinalAddress && !props.childSr) ||
                      (viewAddress && showFinalAddress && !props.childSr)) && (
                      <>
                        <button
                          type="button"
                          className="btn btn-blue login-btn"
                          disabled={
                            props.childSr && !(dormantMoreThanYear == 'true')
                              ? false
                              : showFinalAddress
                              ? (userConsent ? false : true)
                              : (dormantMoreThanYear == 'true') ? true : false
                          }
                          onClick={async () => {
                            if (props.childSr) {
                              submitRequest();
                            }
                             else if (showFinalAddress) {
                                setshowEditAddressOptions(false);
                                props.setLoader(true);
                                setViewAddress(true);
                                submitRequest();
                              } 
                              // else if (accReactFlow || (dormantMoreThanYear == 'true') || showIpvScreen ){
                              //   setShowIpvScreen(true); // condition to be changed if ipv not to be shown for standalone address sr
                              // }
                              else if (serReqId && prefilledBase64) {
                                esignService.getEsignUrl(
                                  prefilledBase64,
                                  serReqId,
                                  "address"
                                );
                              }
                            else {
                              setshowEditAddressOptions(true);
                              setViewAddress(false);
                            }    
                            setShowPrerequisiteLink(false);                         
                          }}
                        >
                          {props.childSr
                            ? "Proceed"
                            : !showFinalAddress
                            ? "Confirm & Proceed"
                            : ((dormantMoreThanYear == 'true') || accReactFlow) // condition to be changed if ipv not to be shown for standalone address sr
                            ? "Proceed & Verify"
                            : "Confirm & E-Sign"}
                        </button>
                        <button
                          type="submit"
                          disabled={
                            (consentType &&
                              (consentType?.includes("email") ||
                                consentType?.includes("mobile") ||
                                consentType?.includes("emailMob"))) ||
                            addressConsent?.includes("Change of Address")
                              ? true
                              : false
                          }
                          className="btn btn-olink btn-olink-address login-btn"
                        >
                          {!(
                            (consentType &&
                              (consentType?.includes("email") ||
                                consentType?.includes("mobile") ||
                                consentType?.includes("emailMob"))) ||
                            addressConsent?.includes("Change of Address")
                          ) && (
                            <a
                              className="btn btn-olink btn-olink-address login-btn "
                              href={
                                RedirectnSource == "onep-sr" 
                                ? config.onePlatformBase + "service-request" 
                                : config.rootUrl + "clientarea/servicerequest"
                              }
                              onClick={() => {
                                clearLocalStorage();
                              }}
                            >
                              Cancel
                            </a>
                          )}
                          {((consentType &&
                            (consentType?.includes("email") ||
                              consentType?.includes("mobile") ||
                              consentType?.includes("emailMob"))) ||
                            addressConsent?.includes("Change of Address")) && (
                            <label className="btn btn-olink login-btn">
                              Cancel
                            </label>
                          )}
                        </button>
                      </>
                    )}
                </div>
              )}
              {showWithoutDigilocker && (
                <>
                  <button
                    type="button"
                    className="btn btn-blue login-btn"
                    disabled={!disabledButton}
                    onClick={() => {
                      if (!props.childSr) {
//                        submitRequest();
                        setshowWithoutDigilocker(false);
                        setViewAddress(true);
                      //  props.setLoader(true);
                        setShowFinalAddress(true);
                        // if (dormantMoreThanYear || accReactFlow) {
                        //   setShowIpvScreen(true);
                        // }
                      } else {
                        setshowWithoutDigilocker(false);
                        setViewAddress(true);
                        setShowFinalAddress(true);
                      }
                    }}
                  >
                    Proceed
                  </button>
                  <button
                    type="submit"
                    disabled={
                      (consentType &&
                        (consentType?.includes("email") ||
                          consentType?.includes("mobile") ||
                          consentType?.includes("emailMob"))) ||
                      addressConsent?.includes("Change of Address")
                        ? true
                        : false
                    }
                    className="btn btn-olink btn-olink-address login-btn"
                  >
                    {!(
                      (consentType &&
                        (consentType?.includes("email") ||
                          consentType?.includes("mobile") ||
                          consentType?.includes("emailMob"))) ||
                      addressConsent?.includes("Change of Address")
                    ) && (
                      <a
                        className="btn btn-olink btn-olink-address login-btn "
                        href={
                          RedirectnSource == "onep-sr" 
                          ? config.onePlatformBase + "service-request" 
                          : config.rootUrl + "clientarea/servicerequest"
                        }
                        onClick={() => {
                          clearLocalStorage();
                        }}
                      >
                        Cancel
                      </a>
                    )}
                    {((consentType &&
                      (consentType?.includes("email") ||
                        consentType?.includes("mobile") ||
                        consentType?.includes("emailMob"))) ||
                      addressConsent?.includes("Change of Address")) && (
                      <label className="btn btn-olink login-btn">Cancel</label>
                    )}
                  </button>
                </>
              )}
            </div>
          )}
        </>
      )
      }
      {showIpvScreen && <VideoVerification setVideoContent={setVideoContent} setIpvcode={setIpvcode} />}
    </div>
    ) : nameDOBMismatch == "nameanddob"? <p className="small-text small-text--subHead red">You are not permitted to raise request as the Name and DOB in your trading account are not matching with PAN. Please connect with your Relationship Manager or contact our nearest branch for the same.</p> 
    : nameDOBMismatch == "name"? <p className="small-text small-text--subHead red">You are not permitted to raise request as Name in your trading account is not matching with PAN. Please connect with your Relationship Manager or contact our nearest branch for the same.</p> 
    : nameDOBMismatch == "dob"? <p className="small-text small-text--subHead red">You are not permitted to raise request as DOB in your trading account is not matching with PAN. Please connect with your Relationship Manager or contact our nearest branch for the same.</p> : ""
    : <p className="help-text red line-ht-standard">You have an ongoing account closure request. During this time, you cannot initiate any request.</p>}
</>
  );
};